if (!window.Eurus.loadedScript.has('search-prompts.js')) {
  window.Eurus.loadedScript.add('search-prompts.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // Only one search-prompt animation may run on the page at a time.
      if (typeof window.__eurusSearchPromptSeq !== 'number') {
        window.__eurusSearchPromptSeq = 0;
      }

      Alpine.data('xSearchPrompts', (element, searchPrompts, enableOnMobile) => ({
        prompts: [],
        seq: 0,

        commonPrefixLength(a, b) {
          const max = Math.min(a.length, b.length);
          let i = 0;
          while (i < max && a[i] === b[i]) i++;
          return i;
        },

        sleep(ms) {
          return new Promise((resolve) => setTimeout(resolve, ms));
        },

        isActive() {
          return this.seq === window.__eurusSearchPromptSeq && element && element.isConnected;
        },

        /**
         * Always assign an absolute string (never +=).
         * That way a mid-frame race cannot leave interleaved characters.
         */
        setPlaceholder(text) {
          if (!this.isActive()) return false;
          element.placeholder = text;
          return true;
        },

        async eraseTo(currentText, keepLen) {
          for (let len = currentText.length; len > keepLen; len--) {
            if (!this.setPlaceholder(currentText.slice(0, len - 1))) return false;
            await this.sleep(70);
          }
          return this.setPlaceholder(currentText.slice(0, keepLen));
        },

        async typeTo(targetText, fromLen) {
          for (let len = fromLen + 1; len <= targetText.length; len++) {
            // Rebuild from the target every tick — never append.
            if (!this.setPlaceholder(targetText.slice(0, len))) return false;
            await this.sleep(90);
          }
          return this.setPlaceholder(targetText);
        },

        async runLoop() {
          if (!this.prompts.length) return;

          let index = 0;
          if (!this.setPlaceholder(this.prompts[0])) return;

          while (this.isActive()) {
            await this.sleep(1400);
            if (!this.isActive()) return;

            const current = this.prompts[index];
            const nextIndex = (index + 1) % this.prompts.length;
            const target = this.prompts[nextIndex];
            const keepLen = this.commonPrefixLength(current, target);

            // Make sure we start erase from the known-good full current prompt.
            if (!this.setPlaceholder(current)) return;

            if (!(await this.eraseTo(current, keepLen))) return;

            await this.sleep(450);
            if (!this.isActive()) return;

            if (!(await this.typeTo(target, keepLen))) return;

            index = nextIndex;
          }
        },

        destroy() {
          // Invalidate this instance so any in-flight awaits exit.
          if (this.seq === window.__eurusSearchPromptSeq) {
            window.__eurusSearchPromptSeq += 1;
          }
          this.seq = -1;
        },

        initSearchPrompt() {
          if (window.matchMedia('(max-width: 768px)').matches && !enableOnMobile) {
            return;
          }

          const prompts = (searchPrompts || [])
            .map((p) => (p == null ? '' : String(p)))
            .filter((p) => p.trim() !== '');

          if (!prompts.length) return;

          if (prompts.length === 1) {
            element.placeholder = prompts[0];
            return;
          }

          // Claim exclusive ownership of the page-level animation slot.
          window.__eurusSearchPromptSeq += 1;
          this.seq = window.__eurusSearchPromptSeq;
          this.prompts = prompts;

          // Cancel any prior controller tied to this DOM node.
          if (element.__eurusSearchPromptStop) {
            try { element.__eurusSearchPromptStop(); } catch (e) {}
          }
          element.__eurusSearchPromptStop = () => {
            if (this.seq === window.__eurusSearchPromptSeq) {
              window.__eurusSearchPromptSeq += 1;
            }
            this.seq = -1;
          };

          this.runLoop();
        },
      }));
    });
  });
}
